<template>
    <div class="sidebar">
      <a href="javascript:void(0)" class="header__search-trigger"></a>
      <!-- <a href="javascript:void(0)" class="header__ai-trigger"></a> -->
      <a href="javascript:void(0)" class="header__menu-toggle" :class="{ 'is-clicked': isMobileMenuVisible }" @click="toggleMenu"><span>{{ $t('navigation.menu') }}</span></a>
        <nav class="header__nav-wrap">
            <CategoryMenuComponent 
            :displayedCategories="displayedCategories" 
            :extraCategories="extraCategories"
            @openCategoryModal="showCategoryModal = true"
            @closeMenu="closeMenu"
            @changeLocale="changeLocale" />

            <SidebarFooterComponent />
        </nav>
        <CategoryDrawerComponent 
        :showCategoryModal="showCategoryModal" 
        @update:showCategoryModal="val => showCategoryModal = val"
        @closeMenu="closeMenu"
        :extraCategories="extraCategories" />
    </div>
  </template>
  
  <script>
  import { ref, computed, watch } from 'vue';
  import CategoryDrawerComponent from '@/components/CategoryDrawerComponent.vue';
  import CategoryMenuComponent from '@/components/CategoryMenuComponent.vue';
  import SidebarFooterComponent from '@/components/SidebarFooterComponent.vue';
  
  import apolloClient from '@/services/apollo-client';
  import { useStore } from 'vuex';
  import { GET_VISIBLE_CATEGORIES } from '@/graphql/categories';
  
  export default {
    components: {
      CategoryDrawerComponent,
      CategoryMenuComponent,
      SidebarFooterComponent,
    },
    setup() {
      const store = useStore(); 
      const showCategoryModal = ref(false);
      const isMobileMenuVisible = ref(false);
      const categoryLimit = 10;
      const categories = ref([]);

      const openCategoryModal = () => {
        // force a reactivity cycle
        showCategoryModal.value = false;
        requestAnimationFrame(() => {
          showCategoryModal.value = true;
        });
      };
      
      const fetchCategories = async () => {
        const { data } = await apolloClient.query({ query: GET_VISIBLE_CATEGORIES });
        categories.value = data.visibleCategories;
      };

      // For mobile: show first set of categories
      // For desktop: show first set of categories
      const displayedCategories = computed(() => {
        return categories.value.slice(0, categoryLimit);
      });

      // For mobile: show remaining categories in the main list
      // For desktop: show remaining categories in the modal
      const extraCategories = computed(() => {
        return categories.value.slice(categoryLimit);
      });
  
      fetchCategories();
  
      const toggleMenu = () => {
        isMobileMenuVisible.value = !isMobileMenuVisible.value;
      };

      const closeMenu = () => {
        isMobileMenuVisible.value = false;
      };

      const changeLocale = (newLocale) => {
        store.dispatch('locale/setLocale', newLocale);
      };

      watch(isMobileMenuVisible, (newValue) => {
        if (newValue) {
          document.body.classList.add('nav-wrap-is-visible');
        } else {
          document.body.classList.remove('nav-wrap-is-visible');
        }
      });

      return {
        showCategoryModal,
        displayedCategories,
        extraCategories,
        isMobileMenuVisible,
        changeLocale,
        toggleMenu,
        closeMenu,
        openCategoryModal
      };
    }
  };
  </script>

